import * as React from 'react';
import { Card, Row, Button, Col } from 'antd';
import '../../../css/UploadProfileContentFive.scss';

interface IUploadProfileContentFiveProps {    
    updates: number;
    uploads: number;
    handleNextClick: any;
    handlePrevClick: any;    
}

interface IUploadProfileContentFiveState {    
    current: number;
}

export default class UploadContentFive extends React.Component<IUploadProfileContentFiveProps
    , IUploadProfileContentFiveState> {

    constructor(props: IUploadProfileContentFiveProps) {
        super(props);
        this.state = { 
            current: 5
        };

        console.log('updates: ', this.props.updates);
        console.log('uploads: ', this.props.uploads);
    }    

    render() {
        return(
            <div className="UploadProfileContentFive"> 
                <Card bordered={false} style={{ margin: '24px 16px' }}>
                    <div>
                        <Row> 
                            <Col span={7} className="infoCol">
                                <div>{'Total Profiles Updated: '}</div>
                            </Col>
                            <Col span={5} className="infoCol">
                                <div>{this.props.updates}</div>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Row> 
                            <Col span={7} className="infoCol">
                                <div>{'Total Profiles Uploaded: '}</div>
                            </Col>
                            <Col span={5} style={{padding: '10px', float: 'left', borderStyle: 'groove'}}>
                                <div>{this.props.uploads}</div>
                            </Col>
                        </Row>
                    </div>
                    <div>
                        <Row>
                            <Col span={10} style={{padding: '10px', width: '48%'}}>              
                                <div className="feebackButton"> 
                                    <Button 
                                        onClick={e => { history.back(); }} 
                                        type="primary"
                                    > 
                                    {'Ok'} 
                                    </Button> 
                                </div>
                            </Col>
                        </Row>
                    </div>
                </Card>
            </div>
        );
    }
    
}


// WEBPACK FOOTER //
// ./src/components/profile/uploadprofilesteps/UploadProfileContentFive.tsx